import { Suspense, lazy, FC } from 'react';
import { useSelector } from 'react-redux';

const PdpSharedAuctionSubscriptionError = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedAuctionSubscriptionError" */ './PdpSharedAuctionSubscriptionError'
        )
);

type Props = {
    hasSubscriptionError: boolean;
};

type RelayVariables = {
    isClient: boolean;
};

type ReduxStoreType = {
    relayVariables: {
        variables: RelayVariables;
    };
};

export const PdpSharedAuctionSubscriptionErrorLazy: FC<Props> = ({ hasSubscriptionError }) => {
    const { isClient } = useSelector<ReduxStoreType, RelayVariables>(
        relay => relay?.relayVariables?.variables || {}
    );

    if (!isClient) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <PdpSharedAuctionSubscriptionError hasSubscriptionError={hasSubscriptionError} />
        </Suspense>
    );
};
